(() => {
  const shouldRemember = (detail, formId) =>
    detail?.formId === formId && (detail.type === 'close' || detail.type === 'submit');
  const stickyActive = (sticky, mobile) => Boolean(mobile && sticky && !sticky.hidden);
  const isTeaserClose = (target, teaserSelector) => Boolean(
    target?.closest?.(`${teaserSelector} .klaviyo-close-form`)
  );

  if (typeof module !== 'undefined' && module.exports) module.exports = { shouldRemember, stickyActive, isTeaserClose };
  if (typeof document === 'undefined') return;

  const script = document.currentScript;
  const formId = script?.dataset.fmNewsletterFormId;
  const teaserSelector = script?.dataset.fmNewsletterTeaserSelector;
  if (!formId || !teaserSelector) return;

  const storageKey = `fm-newsletter-hidden:${formId}`;
  const mobile = matchMedia('(max-width: 749px)');
  let scheduled = false;
  let dismissed = false;

  const remembered = () => {
    if (dismissed) return true;
    try { return sessionStorage.getItem(storageKey) === 'true'; } catch (_error) { return dismissed; }
  };
  const remember = () => {
    dismissed = true;
    try { sessionStorage.setItem(storageKey, 'true'); } catch (_error) {}
  };
  const update = () => {
    scheduled = false;
    const sticky = document.querySelector('.fm-sticky-purchase');
    const hide = remembered() || stickyActive(sticky, mobile.matches);
    document.querySelectorAll(teaserSelector).forEach(teaser => {
      if (hide) {
        if (!teaser.hidden) {
          teaser.dataset.fmNewsletterHidden = 'true';
          teaser.hidden = true;
        }
      } else if (teaser.dataset.fmNewsletterHidden === 'true') {
        if (teaser.hidden) teaser.hidden = false;
        delete teaser.dataset.fmNewsletterHidden;
      }
    });
  };
  const schedule = () => {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(update);
  };

  window.addEventListener('klaviyoForms', event => {
    if (!shouldRemember(event.detail, formId)) return;
    remember();
    schedule();
  });
  document.addEventListener('click', event => {
    if (!isTeaserClose(event.target, teaserSelector)) return;
    remember();
    schedule();
  }, true);
  new MutationObserver(schedule).observe(document.documentElement, {
    subtree: true,
    childList: true,
    attributes: true,
    attributeFilter: ['hidden'],
  });
  mobile.addEventListener?.('change', schedule);
  schedule();
})();
